import { LanguageType } from "@/custom-types";
import { OwnerContractLeaseTypeOption } from "@/graphql/generated";

export const ownerContractLeaseTypeMapper = (type: OwnerContractLeaseTypeOption, language: LanguageType) => {
  const typeMap = {
    en: {
      ASSURED_PAYMENT: 'Assured Payment',
      LEASE_SUBLET: 'Lease Sublet',
      OCCUPATION_MANAGMENT: 'Occupation Management'
    },
    es: {
      ASSURED_PAYMENT: 'Renta Asegurada',
      LEASE_SUBLET: 'Subarriendo',
      OCCUPATION_MANAGMENT: 'Gestión de Ocupación'
    },
  };
  return typeMap[language][type];
};
